import React from 'react'
import { withRouter } from 'react-router-dom'
import { withTranslationCustom } from 'lib/i18next'
import { flowRight } from 'lodash'
import { graphql } from '@apollo/client/react/hoc'
import { NOTIFICATION_TYPE } from 'components/Notifications/Notifications'
import { ERROR_DISPLAY_METHOD } from 'lib/errors'
import { newNotification } from 'lib/utils/store/notifications'
import { appErrorVar } from 'lib/utils/store/cache'

import PageAppError from './Displays/PageAppError'
import HeaderAppError from './Displays/HeaderAppError'

import getAppError from 'graphql/app/getAppError.gql'

class AppErrorHandler extends React.Component {
    constructor (props) {
        super()

        this.state = {
            locationKey: props.location.key,
            appError: props.appError,
            renderableError: true,
        }
    }

    static getDerivedStateFromProps (nextProps, prevState) {
        if (nextProps.appError) {
            const { t, appError } = nextProps

            appErrorVar(null)

            let renderable = true

            if (appError?.displayMethod === ERROR_DISPLAY_METHOD.NOTIFY) {
                renderable = false
                newNotification(
                    NOTIFICATION_TYPE.DANGER,
                    '',
                    t(`${appError.type}.${appError.code}.message`, t('errorMessage.default.content'))
                )
            }

            return {
                appError: nextProps.appError,
                renderableError: renderable,
            }
        } else if (prevState.appError && prevState.locationKey !== nextProps.location.key) {
            return {
                appError: null,
            }
        }

        return null
    }

    renderError () {
        const { children } = this.props
        const { appError } = this.state

        switch (appError.displayMethod) {
        case ERROR_DISPLAY_METHOD.PAGE:
            return <PageAppError appError={appError} />
        case ERROR_DISPLAY_METHOD.HEADER:
            return <HeaderAppError appError={appError} defaultContent={children} />
        default:
            return <PageAppError appError={appError} />
        }
    }

    render () {
        const { renderableError } = this.state

        // Check if we have error to render.
        // Some errors may not require rendering here. For example,
        // notify type of errors are not rendered in AppErrorHandler
        // as the rendering is being done via. Notifications component.
        return renderableError && this.state.appError ? this.renderError() : this.props.children
    }
}

export default withRouter(flowRight(
    graphql(getAppError, {
        name: 'appError',
        options: {
            fetchPolicy: 'cache-only'
        },
        props: (data) => {
            return {
                appError: data.appError.appError,
            }
        },
    }),
)(withTranslationCustom(['errors'])(AppErrorHandler)))
